import {MobileColumn} from '../../model/MobileColumn';
import {MFilterModalComponent} from '../../components/filter-modal/m-filter-modal.component';

const cols: Array<MobileColumn> = [
    {
        field: 'CONTRACT_BIN_ID',
        label: 'Contract Bin ID',
        type: MFilterModalComponent.TYPE_TEXT,
        filter: true,
        sort: true
    },
    {
        field: 'ITEM_ID',
        label: 'Item ID',
        type: MFilterModalComponent.TYPE_TEXT,
        filter: true,
        sort: true
    },
    {
        field: 'CUSTOMER_PART_NO',
        label: 'Customer Part No',
        type: MFilterModalComponent.TYPE_TEXT,
        filter: true,
        sort: true
    },
    {
        field: 'CO1_NAME',
        label: 'Company',
        type: MFilterModalComponent.TYPE_TEXT,
        filter: true,
        sort: true
    },
    {
        field: 'CU1_NAME',
        label: 'Customer',
        type: MFilterModalComponent.TYPE_TEXT,
        filter: true,
        sort: true
    },
    {
        field: 'RA1_SHIP_TO_NAME',
        label: 'Rack',
        type: MFilterModalComponent.TYPE_TEXT,
        filter: true,
        sort: true
    },
    {
        field: 'PL1_NAME',
        label: 'Plant',
        type: MFilterModalComponent.TYPE_TEXT,
        filter: true,
        sort: true
    }
];

export default cols;



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/modules/mobile/views/master-data/m-master-data.cols.ts